module.exports = __webpack_public_path__ + "img/Support-skill-308.c739a599.png";